import React, { useState, type FC, useEffect, useRef } from "react";
import Masonry from "react-responsive-masonry";
import MediaDialog from "@components/MediaDialog";
import useMediaQuery from "@hooks/useMediaQuery";
import ArrowExpanded from "@icons/ArrowExpanded";
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import { Container } from "@components/styles";
import type { GalleryProps, Image, ThumbImageProps } from "./types";
import {
  GalleryWrapper,
  StyledResponsiveMasonry,
  StyledImage,
  Nav,
  Prev,
  Next,
  Expand,
  Item,
} from "./styles";
import { formatAsWebp } from "@utils/hasWebpSupport";

const getRandomIntInclusive = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);

const ThumbImage = ({
  image,
  isMobile,
  index,
  setDialogOpen,
}: ThumbImageProps) => {
  const thumbIndex = getRandomIntInclusive(0, 2);
  let width = 370;
  let height = thumbIndex === 1 ? 400 : 600;

  // const thumbnailImage = getImage(image?.file)
  // if (thumbnailImage) {
  //   thumbnailImage.width = 370
  //
  //   if (thumbIndex === 1) {
  //     thumbnailImage.height = 400
  //   } else {
  //     thumbnailImage.height = 600
  //   }
  // }

  return (
    <StyledImage
      onClick={() => {
        // eslint-disable-next-line no-unused-expressions
        if (!isMobile) {
          setDialogOpen(index);
        }
      }}
    >
      <Expand>
        <ArrowExpanded color="#fff" />
      </Expand>
      <img
        loading="lazy"
        alt={image.alternativeText}
        src={`${process.env.GATSBY_STRAPI_URL}${
          image.url
        }?resize=${width}x${height}${formatAsWebp()}`}
        width={width}
        height={height}
        // height={ thumbIndex === 2
        //   ? 600
        //   : (
        //     thumbIndex === 1
        //       ? 400
        //       : 'auto'
        //   ) }
      />
    </StyledImage>
  );
};

const CachedThumbImage = React.memo(ThumbImage, (prevProps, nextProps) => {
  return prevProps.image === nextProps.image;
});

const Gallery: FC<GalleryProps> = ({ images }) => {
  const isMobile = useMediaQuery("(max-width: 845px)");
  const [dialogOpen, setDialogOpen] = useState<number | null>();
  const imageCount = images?.length;

  return (
    <Container>
      <GalleryWrapper>
        <StyledResponsiveMasonry
          columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
        >
          <Masonry gutter={30}>
            {images?.map((image, index) => {
              return (
                <Item>
                  {/* eslint-disable-next-line react/no-array-index-key */}
                  <CachedThumbImage
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    index={index}
                    image={image}
                    isMobile={isMobile}
                    setDialogOpen={setDialogOpen}
                  />
                  <MediaDialog
                    onClose={() => setDialogOpen(null)}
                    isOpen={dialogOpen === index}
                    isVideo={false}
                    actions={
                      <Nav>
                        <Prev
                          onClick={() => {
                            setDialogOpen(index - 1);
                          }}
                          disabled={index - 1 < 0}
                        />
                        <Next
                          onClick={() => {
                            setDialogOpen(index + 1);
                          }}
                          disabled={index + 1 > imageCount - 1}
                        />
                      </Nav>
                    }
                  >
                    <img
                      loading="lazy"
                      alt={image.alternativeText}
                      src={`${process.env.GATSBY_STRAPI_URL}${
                        image?.url
                      }?width=1920${formatAsWebp()}`}
                      width={1920}
                      //image={ getImage(image?.hiresFile) }
                    />
                  </MediaDialog>
                </Item>
              );
            })}
          </Masonry>
        </StyledResponsiveMasonry>
      </GalleryWrapper>
    </Container>
  );
};

export default Gallery;
